import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, User, Loader2, ArrowRight } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import Logo from '../../components/Logo';
import { useAuth } from '../../context/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login, authed } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authed) navigate('/admin', { replace: true });
  }, [authed, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/admin', { replace: true });
    } catch (err) {
      setError('Invalid username or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#123020] px-4">
      <div className="w-full max-w-[420px]">
        <div className="flex justify-center mb-8">
          <Logo light />
        </div>
        <div className="bg-white rounded-lg shadow-xl p-8">
          <h1 className="font-display text-2xl font-semibold text-[#123020]">Admin Login</h1>
          <p className="text-[14px] text-[#5a6b60] mt-1">Sign in to manage your website.</p>

          <form onSubmit={handleSubmit} className="mt-6 space-y-5">
            <div>
              <Label htmlFor="username" className="text-[#123020] font-medium">Username</Label>
              <div className="relative mt-1.5">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#8a9980]" />
                <Input id="username" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" className="pl-10 h-11 rounded-md border-[#d7d5c8] focus-visible:ring-[#5f9e2c]" autoComplete="username" />
              </div>
            </div>
            <div>
              <Label htmlFor="password" className="text-[#123020] font-medium">Password</Label>
              <div className="relative mt-1.5">
                <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#8a9980]" />
                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="pl-10 h-11 rounded-md border-[#d7d5c8] focus-visible:ring-[#5f9e2c]" autoComplete="current-password" />
              </div>
            </div>
            {error && <p className="text-[13px] text-red-600">{error}</p>}
            <Button type="submit" disabled={loading} className="w-full bg-[#86c93c] hover:bg-[#75b52f] text-[#123020] font-semibold rounded-md h-11">
              {loading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Signing in...</>) : (<>Sign In <ArrowRight className="ml-2 h-4 w-4" /></>)}
            </Button>
          </form>
        </div>
        <p className="text-center text-[12px] text-[#7f9a76] mt-6">Ever Leaf · Private Admin Area</p>
      </div>
    </div>
  );
};

export default Login;
